var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { COLORS, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import CrawlerCompetitionLink from 'app/components/crawlerCompetitions/CrawlerCompetitionLink';
import { topLeagues, topCups, additionalLeagues } from 'app/components/crawlerCompetitions/staticCrawlerCompetitions';
const SCSection = styled.section.withConfig({
  componentId: "sc-7olqay-0"
})(["width:100%;display:flex;background-color:", ";justify-content:center;", ";"], COLORS.lightestGrey, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    justify-content: center;\n  "]))));
const PromoHeadline = styled(Typography).withConfig({
  componentId: "sc-7olqay-1"
})(["&&&{padding-bottom:1.25rem;padding-top:2rem;}"]);
const Content = styled.div.withConfig({
  componentId: "sc-7olqay-2"
})(["display:flex;width:100%;flex-direction:column;margin:0 auto;max-width:1112px;padding:0 1rem 2rem 1rem;"]);
const Container = styled.div.withConfig({
  componentId: "sc-7olqay-3"
})(["display:flex;margin:auto 0;flex-wrap:wrap;justify-content:flex-start;gap:0.75rem;"]);
const SCCrawlerCompetitionLink = styled(CrawlerCompetitionLink).withConfig({
  componentId: "sc-7olqay-4"
})(["&&&{display:flex;flex-basis:11.25rem;flex-grow:1;", "}"], props => props.theme.streamModuleFourElemsPerViews(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      flex-grow: 0;\n  "]))));
const Competitions = () => {
  const topLeaguesContent = /*#__PURE__*/React.createElement(SCCrawlerCompetitionLink, {
    competitionCategory: 'league',
    competitionList: topLeagues
  });
  const topCupsContent = /*#__PURE__*/React.createElement(SCCrawlerCompetitionLink, {
    competitionCategory: 'cup',
    competitionList: topCups
  });
  const additionalLeaguesContent = /*#__PURE__*/React.createElement(SCCrawlerCompetitionLink, {
    competitionCategory: 'league',
    competitionList: additionalLeagues
  });
  return /*#__PURE__*/React.createElement(SCSection, {
    "data-sentry-element": "SCSection",
    "data-sentry-component": "Competitions",
    "data-sentry-source-file": "Competitions.tsx"
  }, /*#__PURE__*/React.createElement(Content, {
    "data-sentry-element": "Content",
    "data-sentry-source-file": "Competitions.tsx"
  }, /*#__PURE__*/React.createElement(PromoHeadline, {
    variant: "headline2",
    "data-sentry-element": "PromoHeadline",
    "data-sentry-source-file": "Competitions.tsx"
  }, "Amateur-Topligen"), /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "Competitions.tsx"
  }, topLeaguesContent), /*#__PURE__*/React.createElement(PromoHeadline, {
    variant: "headline2",
    "data-sentry-element": "PromoHeadline",
    "data-sentry-source-file": "Competitions.tsx"
  }, "Landespokal-Wettbewerbe"), /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "Competitions.tsx"
  }, topCupsContent), /*#__PURE__*/React.createElement(PromoHeadline, {
    variant: "headline2",
    "data-sentry-element": "PromoHeadline",
    "data-sentry-source-file": "Competitions.tsx"
  }, "Weitere beliebte Ligen"), /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "Competitions.tsx"
  }, additionalLeaguesContent)));
};
export default Competitions;